export default "__VITE_ASSET__B5U4ZTyK__"